// Resume48.js
import React from 'react';

const Resume48 = ({ color = "#e91e63" }) => {
  // Create a slightly darker shade for gradient start (approx 20-30% darker)
  const darkerColor = `${color}cc`; // semi-transparent or you can use a proper darker hex if preferred

  return (
    <div
      style={{
        width: '210mm',
        minHeight: '297mm',
        color: '#333333',
        fontFamily: 'Arial, Helvetica, sans-serif',
        display: 'flex',
        margin: '0 auto',
        boxShadow: '0 4px 25px rgba(0,0,0,0.12)',
        overflow: 'hidden'
      }}
    >
      {/* LEFT SIDEBAR - Dynamic gradient based on accent color */}
      <div
        style={{
          width: '38%',
          background: `linear-gradient(180deg, ${darkerColor} 0%, ${color} 100%)`,
          color: '#e8eef7',
          padding: '50px 35px',
          display: 'flex',
          flexDirection: 'column',
          gap: '45px'
        }}
      >
        {/* Photo */}
        <div style={{ alignSelf: 'center' }}>
          <img
            src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80"
            alt="Rufusus Stewart"
            style={{
              width: '180px',
              height: '180px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: `6px solid ${color}`,
              boxShadow: '0 8px 20px rgba(0,0,0,0.4)'
            }}
          />
        </div>

        {/* CONTACT */}
        <div>
          <h3 style={{
            fontSize: '1.35rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '1.6px'
          }}>
            CONTACT
          </h3>
          <div style={{ fontSize: '0.98rem', lineHeight: '1.9', color: '#d0e0f5' }}>
            <div>✉ hello@reallygreatsite.com</div>
            <div>☎ +123-456-7890</div>
            <div>📍 123 Anywhere St., Any City</div>
            <div>🌐 www.reallygreatsite.com</div>
          </div>
        </div>

        {/* SKILLS */}
        <div>
          <h3 style={{
            fontSize: '1.35rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '1.6px'
          }}>
            SKILLS
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            fontSize: '0.98rem',
            lineHeight: '1.9',
            color: '#d0e0f5'
          }}>
            <li>• Logo and Branding Design</li>
            <li>• Layout & Print Design</li>
            <li>• UI/UX Design Basics</li>
            <li>• Typography & Color Theory</li>
            <li>• Social Media Content Creation</li>
            <li>• Motion Graphics (Basic)</li>
          </ul>
        </div>

        {/* EDUCATION */}
        <div>
          <h3 style={{
            fontSize: '1.35rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '1.6px'
          }}>
            EDUCATION
          </h3>
          <div style={{ fontSize: '0.98rem', lineHeight: '1.7', color: '#d0e0f5' }}>
            <strong>Bachelor's Degree in Visual Communication Design</strong><br />
            Universitas Rimberio – 123 Anywhere St., Any City<br />
            2014 – 2018
          </div>
        </div>

    

       
      </div>

      {/* RIGHT CONTENT AREA */}
      <div
        style={{
          width: '62%',
          padding: '50px 45px',
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          gap: '40px'
        }}
      >
        {/* Header - Name & Title */}
        <div>
          <h1 style={{
            fontSize: '2.7rem',
            fontWeight: 'bold',
            margin: '0 0 8px 0',
            color: color,
            lineHeight: '1.05'
          }}>
            RUFUSUS STEWART
          </h1>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            margin: '0 0 20px 0',
            color: color
          }}>
            Graphic Designer
          </h2>
          <hr style={{
            border: 'none',
            borderTop: `3px solid ${color}`,
            margin: '12px 0 28px 0',
            width: '120px'
          }} />
        </div>

        {/* PROFESSIONAL SUMMARY */}
        <div>
          <h3 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            marginBottom: '16px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.2px'
          }}>
            PROFESSIONAL SUMMARY
          </h3>
          <p style={{
            fontSize: '1.02rem',
            lineHeight: '1.7',
            color: '#444'
          }}>
            Creative and detail-oriented Graphic Designer with over 5 years of experience in developing engaging and innovative digital and print designs. Proven ability to transform client ideas into visually impactful designs, with a strong focus on branding, typography, and visual storytelling.
          </p>
        </div>

        {/* WORK EXPERIENCE */}
        <div>
          <h3 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.2px'
          }}>
            WORK EXPERIENCE
          </h3>

          <div style={{ marginBottom: '32px' }}>
            <h4 style={{
              fontSize: '1.22rem',
              margin: '0 0 6px 0',
              color: color
            }}>
              Senior Graphic Designer
            </h4>
            <p style={{
              fontSize: '1rem',
              color: '#555',
              margin: '0 0 12px 0',
              fontStyle: 'italic'
            }}>
              Creative Spark Agency – 123 Anywhere St., Any City<br />
              January 2021 – Present
            </p>
            <ul style={{
              paddingLeft: '20px',
              margin: '0',
              fontSize: '0.98rem',
              lineHeight: '1.7'
            }}>
              <li>Designed branding materials for over 50+ clients, including logos, brochures, and packaging.</li>
              <li>Led a team of junior designers and collaborated with marketing to deliver high-impact visual campaigns.</li>
              <li>Developed visual content for social media, increasing client engagement by up to 40%.</li>
            </ul>
          </div>

          <div>
            <h4 style={{
              fontSize: '1.22rem',
              margin: '0 0 6px 0',
              color: color
            }}>
              Graphic Designer
            </h4>
            <p style={{
              fontSize: '1rem',
              color: '#555',
              margin: '0 0 12px 0',
              fontStyle: 'italic'
            }}>
              Freelance Designer – Remote<br />
              2018 – 2020
            </p>
            <ul style={{
              paddingLeft: '20px',
              margin: '0',
              fontSize: '0.98rem',
              lineHeight: '1.7'
            }}>
              <li>Worked with startups and SMEs to create brand identities, websites, and promotional materials.</li>
              <li>Successfully managed multiple projects with tight deadlines.</li>
            </ul>
          </div>
        </div>

      
      </div>
    </div>
  );
};

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#e91e63", label: "Hot Pink" },
    { value: "#00bcd4", label: "Cyan" },
    { value: "#8bc34a", label: "Light Green" },
    { value: "#ff5722", label: "Deep Orange" },
    { value: "#607d8b", label: "Blue Grey" }
  ]
};

export default Resume48;